import { Button, withStyles, DialogActions } from '@material-ui/core';

const styles = (theme) => ({
  dialogFooter: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: 8,
  },
  actionButton: {
    margin: '0 -4 0 16',
    minWidth: '136px',
    '&$disabledButton': {
      backgroundColor: theme.disabledColor,
      color: theme.TextColor,
      opacity: 0.8
    }
  },
  disabledButton: {},
});

const Action = (props) => {
  const { classes, onClose, onConfirm, isDisabled } = props;
  return (
    <DialogActions className={classes.dialogFooter}>
      <Button onClick={onClose} color="primary" variant="outlined" className={classes.actionButton}>
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        classes={{
          root: classes.actionButton,
          disabled: classes.disabledButton
        }}
        onClick={onConfirm}
        disabled={isDisabled}>
        Assign
      </Button>
    </DialogActions>
  );
};

export default withStyles(styles)(Action);
